import React from "react";
import { observer } from "mobx-react-lite";

import { DamageGroupCode } from "../../../services/damage/DamageGroupCode";
import useThemeService from "../../../services/theme-service/ThemeService";
import { translationService } from "../../../services/translation/TranslationService";
import { Dropdown } from "../../../components/dropdown/Dropdown";

interface EditGroupCodeProps {
  value: DamageGroupCode | null;
  groupCodes: DamageGroupCode[];
  onChange: (groupCode: DamageGroupCode) => void;
  setFieldValue: Function;
}

export default observer(function EditGroupCode(props: EditGroupCodeProps) {
  const { value, groupCodes, onChange, setFieldValue } = props;

  const { themeClass } = useThemeService();

  return (
    <div className="field" id="group-code-field">
      <label className={themeClass(["label-edit"])}>
        {translationService.translate("general.damage.group-code")}
      </label>
      <div className="form-element-container">
        <Dropdown
          selectedOption={
            value && value.code ? { ...value, id: value.code, name: value.label } : null
          }
          options={groupCodes.map((x) => ({
            ...x,
            id: x.code,
            name: x.label,
          }))}
          onChange={onChange}
          fieldName="groupCode"
          setFieldValue={setFieldValue}
          placeholderKey="EditDamage.groupCode.selection"
          canClearSelection
        />
      </div>
    </div>
  );
});
